import * as React from "react";

import IosIcon from "./IosIcon";
import HttpIcon from "./HttpIcon";
import AndroidIcon from "./AndroidIcon";
import JSIcon from "./JSIcon";

interface PlatformIconProps {
	iconSrc: any;
	onClick: () => void;
	isSelected: boolean;
}

const PlatformIcon = (props: PlatformIconProps) => (
	<div
		style={{
			display: "flex",
			flex: 1,
			justifyContent: "center",
			alignContent: "center",
			justifyItems: "center",
			alignItems: "center",
			cursor: "pointer",
			paddingTop: "0.5rem",
			borderBottom: "0.5rem solid transparent",
			borderBottomColor: props.isSelected ? "#607D8B" : "transparent",
		}}
		onClick={props.onClick}
	>
		<props.iconSrc
			style={{
				margin: 0,
			}}
			fillColor={props.isSelected ? "#607d8b" : "#F0F2F7"}
			iconColor={props.isSelected ? "#FFFFFF" : "#636363"}
		/>
	</div>
);

interface PlatformSelectorProps {
	value: string;
	onChangeValue: (value: string, keepDrawerOpen: boolean) => void;
}

/**
 * provides a tabular selection for supported doc platforms
 */
const PlatformSelector = (props: PlatformSelectorProps) => (
	<>
		<PlatformIcon
			iconSrc={HttpIcon}
			onClick={() => props.onChangeValue("http", true)}
			isSelected={props.value === "http"}
		/>

		<PlatformIcon
			iconSrc={IosIcon}
			onClick={() => props.onChangeValue("ios", true)}
			isSelected={props.value === "ios"}
		/>

		<PlatformIcon
			iconSrc={AndroidIcon}
			onClick={() => props.onChangeValue("android", true)}
			isSelected={props.value === "android"}
		/>

		<PlatformIcon
			iconSrc={JSIcon}
			onClick={() => props.onChangeValue("web", true)}
			isSelected={props.value === "web"}
		/>
	</>
);

export default PlatformSelector;



// WEBPACK FOOTER //
// ./src/components/PlatformSelector/PlatformSelector.tsx